var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, spacings } from '../themes/variables';
const spacingTypeMap = {
    p: 'padding',
    m: 'margin',
};
const Wrapper = styled.div `
  /* TODO: Try to inject the CSS directly instead of selecting them to do so */
  ${props => {
    if (props.applyToChildren) {
        return css `
        & > * {
          ${props.defaultSpacings}
          ${props.mediaQueries}
        }
      `;
    }
    return css `
      ${props.defaultSpacings}
      ${props.mediaQueries}
    `;
}}
`;
/**
 * Returns spacing value or "auto"
 * @param spacing {Spacings}
 */
function mapSpacing(spacing) {
    if (!spacing)
        return undefined;
    if (spacing === 'auto')
        return 'auto';
    return spacings[spacing];
}
/**
 * Returns object with type, side and value of the spacing
 * @param key {string}
 * @param spacing {Spacing}
 */
function getSpacingParams(key, spacing) {
    const type = spacingTypeMap[key.slice(0, 1)];
    const side = key.slice(-1);
    const value = mapSpacing(spacing);
    return { type, side, value };
}
/**
 * Returns css rules by given properties
 * @param spacingProps {SpacingsObject}
 */
function createSpacings(spacingProps) {
    return Object.entries(spacingProps).map(([key, index]) => {
        const { type, side, value } = getSpacingParams(key, index);
        /* Stylelint fails to parse a dynamic property */
        /* stylelint-disable property-no-unknown */
        if (side === 'x') {
            return css `
        ${type}-left: ${value};
        ${type}-right: ${value};
      `;
        }
        if (side === 'y') {
            return css `
        ${type}-top: ${value};
        ${type}-bottom: ${value};
      `;
        }
        if (side === 't') {
            return css `
        ${type}-top: ${value};
      `;
        }
        if (side === 'b') {
            return css `
        ${type}-bottom: ${value};
      `;
        }
        if (side === 'l') {
            return css `
        ${type}-left: ${value};
      `;
        }
        if (side === 'r') {
            return css `
        ${type}-right: ${value};
      `;
        }
        return css `
      ${type}-top: ${value};
      ${type}-bottom: ${value};
      ${type}-left: ${value};
      ${type}-right: ${value};
    `;
        /* stylelint-enable property-no-unknown */
    });
}
/**
 * Returns css rules with media queries by given properties
 * @param props {MediaQueriesProps}
 */
function createMediaQueries(props) {
    if (!props)
        return undefined;
    return Object.entries(props).map(([key, value]) => {
        const cssRules = value && createSpacings(value);
        return css `
      @media (min-width: ${breakpoints[key]}) {
        ${cssRules}
      }
    `;
    });
}
export function Spacing(_a) {
    var { children, media = undefined, applyToChildren = false, asHtmlTag = 'div' } = _a, props = __rest(_a, ["children", "media", "applyToChildren", "asHtmlTag"]);
    const defaultSpacings = createSpacings(props);
    const mediaQueries = createMediaQueries(media);
    return (React.createElement(Wrapper, Object.assign({ as: asHtmlTag, defaultSpacings: defaultSpacings, mediaQueries: mediaQueries, applyToChildren: applyToChildren }, props), children));
}
